import {
  ArticleHeading2,
  ArticleParagraph1,
  ArticleParagraph2,
  IconChevronDownSmall16,
  IconChevronUpSmall16,
} from '@cian/ui-kit';

import { useCallback, useLayoutEffect, useRef, useState } from 'react';

import { IDescriptionProps } from './types';

import * as styles from './styles.css';

export const DEFAULT_LINE_COUNT = 8;
export const DEFAULT_MORE_NOT_EXPANDED_TEXT = 'Читать больше';
export const DEFAULT_MORE_EXPANDED_TEXT = 'Скрыть';

export function Description(props: IDescriptionProps) {
  const {
    description,
    showLines = DEFAULT_LINE_COUNT,
    moreNotExpandedText = DEFAULT_MORE_NOT_EXPANDED_TEXT,
    moreExpandedText = DEFAULT_MORE_EXPANDED_TEXT,
  } = props;

  const [expanded, setExpanded] = useState(false);
  const [clamped, setClamped] = useState(false);
  const paragraphRef = useRef<HTMLParagraphElement | null>(null);

  const toggleLines = useCallback((event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();

    setExpanded(prevExpanded => !prevExpanded);
  }, []);

  useLayoutEffect(() => {
    const measure = () => {
      const paragraph = paragraphRef.current;

      if (paragraph) {
        setClamped(paragraph.scrollHeight > paragraph.clientHeight);
      }
    };

    measure();
    window.addEventListener('resize', measure);

    return () => window.removeEventListener('resize', measure);
  }, [description, showLines, expanded]);

  if (!description) {
    return null;
  }

  const descriptionTextView = expanded ? (
    <p className={styles['paragraph']}>{description}</p>
  ) : (
    <p
      ref={paragraphRef}
      className={`${styles['paragraph']} ${styles['paragraph-clamped']}`}
      data-testid="lines-ellipsis-test-id"
      style={{ WebkitLineClamp: showLines }}
    >
      {description}
    </p>
  );

  return (
    <div className={styles['description']} data-nav-tab="description/О коворкинге" id="description">
      <div>
        <ArticleHeading2 as="span" color="black_100" fontWeight="bold">
          О коворкинге
        </ArticleHeading2>
      </div>
      <div className={styles['text']}>
        <ArticleParagraph1 as="span" color="black_100" fontWeight="normal">
          {descriptionTextView}
        </ArticleParagraph1>
        <div className={styles['toggle']} data-testid="toggle-lines-test-id" onClick={toggleLines}>
          <span>
            <ArticleParagraph2 as="span" color="primary_100" fontWeight="normal">
              {clamped && !expanded && moreNotExpandedText}
              {expanded && moreExpandedText}
            </ArticleParagraph2>
            {clamped && !expanded && (
              <span className={styles['icon']}>
                <IconChevronDownSmall16 color="primary_100" display="inline-block" />
              </span>
            )}
            {expanded && <IconChevronUpSmall16 color="primary_100" display="inline-block" />}
          </span>
        </div>
      </div>
    </div>
  );
}
